<template>
  <header>
    <div class="center-title">
      <div class="simple">
        <div class="icon">
          <img
            :src="require('@/assets/images2/icon13.png')"
            v-if="weather.weather"
          />
        </div>
        <div class="title">
          <span>{{weather.temperature}}°C</span>
          <div>{{ weather.weather }}</div>
        </div>
        <div class="t_c">
          <div>温度 ：<span>{{weather.temperature}}°C</span></div>
          <div>湿度 ：<span>{{weather.humidity}}%</span></div>
        </div>
      </div>

      <div class="img">
        <img
          :src="require('@/assets/images2/title.png')"
          alt=""
          class="imgtitle"
        />
      </div>

      <div class="t_right">
        <div class="times">
          {{ week + "  " + " " + times }}
        </div>
        <div class="time">
          {{ time }}
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      time: "",
      times: "",
      week: "",
      weather: {},
    };
  },
  created() {
    this.getNowDate();
    this.getWeekDate();
    this.getWeather();
    setInterval(() => {
      this.getNowDate();
    }, 1000 * 30);
  },
  methods: {
    getNowDate() {
      var myDate = new Date();
      var year = myDate.getFullYear(); //获取当前年
      var mon = myDate.getMonth() + 1; //获取当前月
      var date = myDate.getDate(); //获取当前日
      var hours = myDate.getHours(); //获取当前小时
      var minutes = myDate.getMinutes(); //获取当前分钟
      // var seconds = myDate.getSeconds(); //获取当前秒
      var now = year + "年" + mon + "月" + date + "日";
      this.time = now;
      this.times = hours + "：" + minutes;
    },
    getWeekDate() {
      var now = new Date();
      var day = now.getDay();
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      var week = weeks[day];
      this.week = week;
      console.log(week, "week");
    },

    //获取天气
    getWeather() {
      axios({
        method: "get",
        url: "https://restapi.amap.com/v3/weather/weatherInfo?city=371300&key=235ee8b8c122ed41052f6a914d516159",
      }).then((res) => {
        console.log(res, 1111);
        this.weather = res.data.lives[0];
      });
    },
  },
};
</script>
<style scoped>
header {
  width: 100%;
  height: 116px;
  background: url("~@/assets/images2/bg1.png") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  position: relative;
}

.center-title {
  width: 3840px;
  padding: 0 132px;
  box-sizing: border-box;
  font-size: 30px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.simple {
  width: 615px;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 10px 0;
  box-sizing: border-box;
  
}
.icon img {
  width: 70px;
  height: auto;
}
.title {
  width: 100px;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-left: 3%;
}
.title div {
  font-size: 22px;
  line-height: 30px;
  color: white;
}
.title span {
  font-size: 40px !important;
  color: white;
  line-height: 45px;
}
.t_c {
  width: 300px;
  display: flex;
  flex-direction: row;
  align-content: flex-end;
  color: white;
  font-size: 22px;
  padding: 10px 0;
  box-sizing: border-box;
}
.t_c div {
  width: 50%;
  margin-left: 4%;
  line-height: 40px;
}
.t_c div span {
  font-size: 26px;
  font-weight: 550;
  color: #f5b800 !important;
  margin-left: 3%;
}

.t_right {
  width: 190px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}
.img {
  width: 2340px;
  height: 100px;
  background: url("~@/assets/images2/tit.png") no-repeat;
  background-size: cover;
  margin-top: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 750px;
  bottom: -11px;
}
.imgtut {
  position: relative;
}
.imgtitle {
  display: block;
  width: 759px;
  height: 48px;
  margin-bottom: 10px;
}
.time {
  /* color: "#fff"; */
  font-size:24px;
  color: aliceblue;
}
.times {
  font-size: 26px;
  font-weight: bold;
  color: aliceblue;
}
</style>
